import * as awsAPI from './awsConnect';
export default awsAPI;
